export default "__VITE_ASSET__BXwW6Q_g__"